import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolSyntheticAction } from './symbolSynthetic.action';
import { symbolSyntheticInitialState } from './symbolSynthetic.constant';
import { ISyntheticSymbolStore } from './symbolSynthetic.interface';

export const symbolSyntheticReducer = reducerWithInitialState(symbolSyntheticInitialState)
  .case(SymbolSyntheticAction.load.started, (state, params) => {
    const { data } = state;
    const symbolData = data[params.symbolId];

    return {
      ...state,
      data: {
        ...data,
        [params.symbolId]: {
          ...symbolData,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(SymbolSyntheticAction.load.done, (state, { params, result }): ISyntheticSymbolStore => {
    return {
      ...state,
      data: {
        ...state.data,
        [params.symbolId]: {
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(SymbolSyntheticAction.load.failed, (state, { params }) => {
    const { data } = state;
    const symbolData = data[params.symbolId];

    return {
      ...state,
      data: {
        ...data,
        [params.symbolId]: {
          ...symbolData,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .cases([SymbolSyntheticAction.loadList.started, SymbolSyntheticAction.processing.started], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(SymbolSyntheticAction.loadSourceSymbols.started, (state) => {
    return {
      ...state,
      sourceSymbolsData: {
        ...state.sourceSymbolsData,
        networkStatus: NetworkStatus.Started,
      },
    };
  })
  .case(SymbolSyntheticAction.loadSourceSymbols.done, (state, { result }): ISyntheticSymbolStore => {
    return {
      ...state,
      sourceSymbolsData: {
        list: result,
        networkStatus: NetworkStatus.Done,
      },
    };
  })
  .case(SymbolSyntheticAction.loadSourceSymbols.failed, (state) => {
    return {
      ...state,
      sourceSymbolsData: {
        ...state.sourceSymbolsData,
        networkStatus: NetworkStatus.Failed,
      },
    };
  })
  .case(SymbolSyntheticAction.loadList.done, (state, { result }): ISyntheticSymbolStore => {
    const { totalCount, filteredCount } = result;

    return {
      ...state,
      totalCount,
      filteredCount,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolSyntheticAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .cases([SymbolSyntheticAction.processing.done, SymbolSyntheticAction.processing.failed], (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolSyntheticAction.update.done, (state, { params }): ISyntheticSymbolStore => {
    return {
      ...state,
      data: {
        ...state.data,
        [params.symbolId]: {
          ...state.data[params.symbolId],
          priceDigits: params.priceDigits,
        },
      },
    };
  })
  .case(SymbolSyntheticAction.destroy, () => ({
    ...symbolSyntheticInitialState,
  }));
